import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';

const SEO = ({ 
  title, 
  description, 
  keywords,
  type = 'website',
  name = 'Elixir',
  twitterCard = 'summary_large_image',
  canonical
}) => {
  const siteUrl = 'https://www.shop.elixir-honey.com';
  const defaultDescription = "Discover Elixir, the Mediterranean's liquid gold. Premium honey varieties from Tunisia's sun-drenched lands, crafted with traditional methods and presented with unparalleled elegance. Experience the art of honey, elevated.";
  const defaultKeywords = `
    Mediterranean honey,
    premium honey varieties,
    Tunisian honey,
    organic honey,
    luxury honey,
    artisanal honey,
    natural honey,
    health benefits of honey,
    gourmet honey,
    traditional beekeeping
  `;

  const fullTitle = title 
    ? `${title} | Elixir - Mediterranean's Liquid Gold`
    : 'Elixir - Mediterranean\'s Liquid Gold | Premium Honey Varieties';

  const canonicalUrl = canonical || (typeof window !== "undefined" ? window.location.href : siteUrl);

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      <link rel="icon" type="image/x-icon" href="/images/favicon.ico" />

      {/* Canonical Tag */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:site_name" content={name} />

      {/* Twitter */}
      <meta property="twitter:card" content={twitterCard} />
      <meta property="twitter:url" content={siteUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description || defaultDescription} />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": name,
          "url": siteUrl,
          "description": description || defaultDescription,
          "brand": {
            "@type": "Brand",
            "name": "Elixir"
          },
          "offers": {
            "@type": "Offer",
            "category": "Premium Honey Products"
          },
          "featureList": [
            "Mediterranean Honey Varieties",
            "Traditional Beekeeping Methods",
            "Organic and Natural",
            "Premium Quality",
            "Health Benefits",
            "Luxury Presentation"
          ]
        })}
      </script>
    </Helmet>
  );
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  twitterCard: PropTypes.string,
  canonical: PropTypes.string
};

export default SEO; 